const isLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const config = {
  // Uses local PHP backend (port 8080) when developing locally, live API in production
  getMyCollege: isLocal ? "http://localhost:8080" : "https://api.arinfotechsolutions.com",
  apiUrl: isLocal ? "http://localhost:8080" : "https://api.arinfotechsolutions.com",
  cookieName: "ar_user",
  sessionCookie: "ar_sess",
};